import React, {
  useRef,
  useEffect,
  useContext,
  useCallback,
  useState,
} from 'react'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

import AuthContext from '../../shared/contexts/AuthContext'

import { useAlert } from '../../shared/components'
import SlashScreen from '../../shared/components/SlashScreen'

import useGoogleAnalytics from '../../shared/hooks/useGoogleAnalytics'

import useSecurity from '../../security/useSecurity'

import { ExecutiveData } from '../../models'
import { useSecurityAction } from '../../store/ducks/security'

import { ERROR_MISSED_APPOINTMENT } from '../../constants'

import useUserClient from '../../clients/UserClient/useUserClient'

const AccessCallback = () => {
  const {
    setUser,
    setExecutive,
    setAssistants,
    setSuperIntendent,
  } = useSecurityAction()
  const {
    user,
    isLoginSocialNetwork,
  } = useContext(AuthContext)
  const { signout, cleanAllData } = useSecurity()
  const { event } = useGoogleAnalytics()

  const history = useHistory()
  const { addMsgDanger } = useAlert()

  const userClient = useUserClient()

  const [isProcessing, setIsProcessing] = useState(false)

  const handleSuccess = useCallback((owner, loggedUser) => {
    try {
      const {
        name,
        phone,
        mobilePhone,
        phone2,
        mobilePhone2,
        updateDeniedAt,
        isNewUser,
        isResponsible,
        ticketsExpired,
        trackSaleSchedule,
        cpfcnpj: cpfCnpj,
        hasAceptedTermsOfUse,
        newExecutiveNotification,
      } = loggedUser

      const {
        uid,
        email,
        photoURL,
        displayName,
      } = user

      const nameUser = name ?? displayName
      setUser({
        uid,
        email,
        cpfCnpj,
        phone,
        mobilePhone,
        phone2,
        mobilePhone2,
        updateDeniedAt,
        ticketsExpired,
        name: nameUser,
        newUser: isNewUser || false,
        avatar: photoURL,
        hasAceptedTermsOfUse,
        newExecutiveNotification,
        isTrackSaleSchedule: trackSaleSchedule || {},
        isResponsibleClient: isResponsible || false,
      })

      if (owner) {
        const assistantsData = loggedUser?.assistants?.map((item) => ExecutiveData({
          ...item?.result?.records[0]?.owner,
          ...item?.result?.photo,
        }))

        const superIntendentData = {
          ...loggedUser?.superIntendent?.result?.records[0]?.owner,
          ...loggedUser?.superIntendent?.result?.photo,
        }
        setAssistants(assistantsData)
        setExecutive(ExecutiveData(owner))
        setSuperIntendent(ExecutiveData(superIntendentData))
        localStorage.setItem('newExecutiveNotification', loggedUser?.newExecutiveNotification)
      }

      event('Acesso', 'Cliente', nameUser || '')

      console.log('[AccessCallback] Login successful, redirecting to home')

      // Add delay to ensure state is persisted
      setTimeout(() => {
        setIsProcessing(false)
        history.replace('/')
      }, 100)
    } catch (error) {
      console.error('[AccessCallback] Error in handleSuccess:', error)
      setIsProcessing(false)
      signout().then(() => {
        history.replace('/login')
      })
    }
  }, [
    user,
    history,
    event,
    setUser,
    setExecutive,
    setAssistants,
    setSuperIntendent,
    signout,
  ])

  const handleExecutive = useCallback((loggedUser) => {
    try {
      const { executive } = loggedUser
      const executiveData = executive?.result?.done && executive?.result?.totalSize > 0
        ? executive?.result?.records[0]
        : {}

      if (isEmpty(executiveData)) {
        handleSuccess(null, loggedUser)
        return
      }

      const { owner } = executiveData
      handleSuccess({ ...owner, ...executive?.result?.photo }, loggedUser)
    } catch (error) {
      console.error('[AccessCallback] Error in handleExecutive:', error)
      handleSuccess(null, loggedUser)
    }
  }, [
    handleSuccess,
  ])

  const loginUserRequest = useCallback(() => {
    console.log('[AccessCallback] Starting loginUserRequest')

    userClient().loginUser().then(({ data: loginUserData }) => {
      console.log('[AccessCallback] loginUser successful')

      const getIpAddress = async () => {
        try {
          const res = await userClient().getIPAddress()
          localStorage.setItem('ipAddress', res?.ip)
          userClient().sendIPAddress(res?.ip)
        } catch (error) {
          console.error('[AccessCallback] Error getting IP address:', error)
        }
      }
      getIpAddress()

      handleExecutive({ ...loginUserData?.data })
    }, (error) => {
      console.error('[AccessCallback] loginUser failed:', error)
      setIsProcessing(false)

      if (error?.data?.message === ERROR_MISSED_APPOINTMENT && error?.status === 401) {
        cleanAllData()
        addMsgDanger({
          message: error?.data?.message,
          labelButton: 'Fechar',
          action: () => window.location.reload(),
        })
        history.replace('/login')
      } else {
        signout().then(() => {
          if (error.status === 400 && isLoginSocialNetwork) {
            setTimeout(() => history.replace('/register', {
              userSocialNetwork: {
                email: user?.email,
                name: user?.displayName,
              },
            }), 100)
            return
          }
          setTimeout(() => {
            history.replace('/login')
          }, 100)
        })
      }
    })
  }, [
    user,
    history,
    signout,
    cleanAllData,
    userClient,
    addMsgDanger,
    handleExecutive,
    isLoginSocialNetwork,
  ])

  const getIpAddress = async () => {
    try {
      const res = await userClient().getIPAddress()
      localStorage.setItem('ipAddress', res?.ip)
    } catch (error) {
      console.error('[AccessCallback] Initial IP address fetch failed:', error)
    }
  }

  useEffect(() => {
    getIpAddress()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const teste = useRef(false)

  useEffect(() => {
    if (user && !teste.current && !isProcessing) {
      console.log('[AccessCallback] Starting authentication flow')
      setIsProcessing(true)
      loginUserRequest()
    }

    return () => {
      teste.current = true
    }
  }, [
    user,
    loginUserRequest,
    isProcessing,
  ])

  return (<SlashScreen />)
}

export default AccessCallback
